import { render, staticRenderFns } from "./IntegralMall.vue?vue&type=template&id=1a5c3ffe&scoped=true&"
import script from "./IntegralMall.vue?vue&type=script&lang=js&"
export * from "./IntegralMall.vue?vue&type=script&lang=js&"
import style0 from "./IntegralMall.vue?vue&type=style&index=0&id=1a5c3ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c3ffe",
  null
  
)

export default component.exports